import React from "react"
import styled from "styled-components"

import { mediaDown } from "styles/media"
import * as spacings from "styles/spacing"
import Content1 from "images/content-1.png"
import Content2 from "images/content-2.png"
import Content3 from "images/content-3.png"
import { lime, sunny } from "styles/colors"

const Container = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto;
  margin-top: ${spacings.xxxxLarge};
  justify-content: center;
  max-width: 900px;

  ${mediaDown.medium`
    flex-direction: column;
    align-items: flex-start;
    margin-top: ${spacings.large};
  `}

  ${mediaDown.medium`
    padding-left: 0px;
  `}

  ${mediaDown.large`
    max-width: 750px;
  `}
`

const ImageContainer = styled.div`
  position: relative;
  margin: 0 ${spacings.medium};
  margin-bottom: 0px;

  &::before {
    content: "";
    position: absolute;
    top: ${props => (props.bottom ? "calc(100% - 7px)" : "-4px")};
    ${props => {
      if (props.start) {
        return `left: ${spacings.medium};`
      }

      if (props.middle) {
        return `left: ${(100 - props.width) / 2}%;`
      }

      if (props.end) {
        return `left: calc(${100 - props.width}% - ${spacings.medium});`
      }
    }}
    height: 8px;
    width: ${props => `${props.width}%`};
    background: -webkit-linear-gradient(0deg, ${lime} 0%, ${sunny} 100%);
  }

  ${mediaDown.medium`
    margin-bottom: ${spacings.large};

    &:nth-child(1) {
      width: 240px;
    }

    &:nth-child(2) {
      width: 200px;
    }

    &:nth-child(3) {
      width: 320px;
    }
  `}
`

export default () => {
  return (
    <Container>
      <ImageContainer bottom end width={60}>
        <img src={Content1} />
      </ImageContainer>
      <ImageContainer bottom middle width={80}>
        <img src={Content2} />
      </ImageContainer>
      <ImageContainer top start width={60}>
        <img src={Content3} />
      </ImageContainer>
    </Container>
  )
}
